import { IconMailExclamation } from '@tabler/icons-react';
import { iconProps } from 'components/icon-props';
import { useCompanyConfiguration } from 'init/use-company-configuration';
import { i18nKeys } from 'locales/source/i18nKeys';
import type { InvoiceAction, UnhandledInvoice } from 'modules/AtRisk/api/use-load-unhandled-client';
import type { ActionButtonDefinition } from '../action-button-definition';
import { useSendFormalNotice } from '../api/use-send-formal-notice';
import { useReminderWizardAction } from './use-reminder-wizard-action';

export function useFormalNotice(): (
  action: InvoiceAction,
  invoices: Array<UnhandledInvoice>,
) => ActionButtonDefinition {
  const { default_templates } = useCompanyConfiguration();
  const { sendFormalNotice } = useSendFormalNotice();

  return useReminderWizardAction({
    documentType: 'formal_notice',
    translationKey: i18nKeys.TEMPLATE_TYPES.FORMAL_NOTICE,
    icon: <IconMailExclamation {...iconProps()} />,
    templateId: default_templates.formal_notice.id?.toString() ?? '',
    send: sendFormalNotice,
  });
}
